<template>
  <div class="junminPersonalInfoForm">
    <el-form class="form" ref="form" :model="form" label-width="176px" :rules="rules">
            <el-form-item label="姓名：" prop="name">
                <el-input v-model="form.name" placeholder="请输入姓名" style="width:320px" maxlength="15"
                    show-word-limit :disabled="isRealName"></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="phone">
                <el-input v-model="form.phone" :disabled="isPhone" placeholder="请输入联系电话" style="width:320px"></el-input>
            </el-form-item>
            <el-form-item label="身份证号：" prop="idCardNo">
                <el-input v-model="form.idCardNo" :disabled="isRealName" placeholder="请输入身份证号" style="width:320px"></el-input>
            </el-form-item>
            <el-form-item label="邮箱：" prop="email">
                <el-input v-model="form.email" :disabled="isEmail" placeholder="请输入邮箱" style="width:320px"></el-input>
            </el-form-item>
            <el-form-item label="工作单位：" prop="workUnit">
                <el-input v-model="form.workUnit" placeholder="请输入工作单位" maxlength="30" show-word-limit
                    style="width:320px"></el-input>
            </el-form-item>
            <el-form-item label="详细地址：" prop="address">
                <el-input type="textarea" :rows="4" maxlength="150" show-word-limit v-model="form.address" placeholder="请输入详细地址"
                    style="width:320px"></el-input>
                <p class="tips">地址用于证书邮寄，请尽量填写详细</p>
            </el-form-item>
            <el-form-item>
                <el-button class="saveBtn" type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
        </el-form>
  </div>
</template>

<script>
import { phoneValidator, emailValidator, idCardValidator } from '../utils/validator';
export default {
    name:'personalInfoForm',
    data() {
        return {
            loading: false,
            isRealName: false,
            isPhone: false,
            isEmail: false,
            filterOptions: [],
            monthrange: [],
            form: {
                id: null,
                name: '',//姓名
                idCardNo: '',//证件号
                phone: '',//联系电话
                address: '',//联系地址
                email: '',//邮箱
                workUnit: ''//工作单位
            },
            rules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur', }],
                idCardNo: [
                    { required: true, message: '请输入身份证号', },
                    {
                        validator: idCardValidator,
                        trigger: 'blur',
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: '请输入手机号',
                        trigger: 'blur',
                    },
                    {
                        validator: phoneValidator,
                        trigger: 'blur',
                    },
                ],
                address: [
                    {
                        required: true,
                        message: '请输入详细地址',
                        trigger: 'blur',
                    },
                ],
                email: [
                    {
                        required: true,
                        message: '请输入邮箱',
                        trigger: 'blur',
                    },
                    {
                        validator: emailValidator,
                        trigger: 'blur',
                    }
                ],
                workUnit: [
                    {
                        required: true,
                        message: '请输入工作单位',
                        trigger: 'blur',
                    },
                ],
            },

        }
    },
    async mounted() {
        this.getUserInfo();
    },
    methods: {
        getUserInfo(){
            let registerWay = localStorage.getItem('registerWay');
            this.$api.lvjUser.queryUserInfoBycn({}).then(res => {
                let data = res.data;
                if(data){
                    this.form = data;
                    this.accountProfileByAccountId();
                    // this.isPhone = registerWay=='phone'?true:false;
                    this.isPhone = data.phone?true:false;
                    this.isEmail = registerWay=='mail'?true:false;
                }
            });
        },
        accountProfileByAccountId(){
            this.$api.lvjUser.accountProfileByAccountId({}).then(res => {
                let data = res.data;
                if(res.success){
                    if(data == 0){
                        this.isRealName = false;
                    }else{
                        this.isRealName = true;
                    }
                }
            });
        },
        onSubmit() {
            console.log(this.form, '提交数据--')
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.updateUserInfo();    
                }
            })
        },
        updateUserInfo() {
            let params = this.form;
            // let way = localStorage.getItem('registerWay');
            // if(way == 'phone'){
            //     params.phone = '';
            // }else{
            //     params.email = '';
            // }
            this.$api.lvjUser.updateBycUserId(params).then(res => {
                if (res.success) {
                    this.$store.commit('saveSubUserInfo', res.data)
                    localStorage.setItem('subUserInfo', JSON.stringify(res.data))
                    if (localStorage.getItem('frontendConfig')) {
                        let val = JSON.parse(localStorage.getItem('frontendConfig')).value;
                        this.$router.push(val || '/');
                        console.log("跳转到val地址")
                    }else{
                        this.$router.push('/personalCenter');
                    }
                }
            })
        },

    }
}
</script>

<style lang="stylus" scoped>
    .junminPersonalInfoForm
        width 822px
        margin 0 auto
    .formItem
        width 640px
    .el-form-item
        margin-bottom 22px
        /deep/ .el-form-item__label
            font-size 16px
            color #303133
        /deep/ .el-form-item__content
            line-height 40px
        /deep/ .el-radio__label
            font-size 16px
            color #303133
        /deep/ .el-input__inner
            border-radius 0
    .footer
        // margin-bottom 48px
        text-align center
        .opeBtn1,.opeBtn2
            display inline-block
            margin-top 38px
            width 100px
            height 40px
            font-size 16px
            color #ffffff
            text-align center
            line-height 40px
            cursor pointer
        .opeBtn1
            background #DCDCDC
        .opeBtn2
            margin-left 17px
            background #1972FF
    // 图片上传
    .uploadItem
        .tip 
            >p
                font-size 14px
                color #C1C1C1
                line-height 22px
    .avatar-uploader
        display inline-block
    .avatar-uploader /deep/ .el-upload 
        width: 130px
        height: 195px
        border: 1px solid #E6E6E6
        cursor: pointer
        position: relative
        overflow: hidden
    
    .uploader-icon 
        width: 36px
        height: 36px
        margin 0 auto
        margin-top 80px
        >img
            width 100%
            display block
            
    
    .avatarImg 
        width: 130px
        display: block
    .updateAvatarWrapper
        position absolute
        left 0
        bottom 0
        width 100%
        height 32px
        background rgba(255,255,255,.7)
        .updateAvatar
            margin 0 auto
            margin-top 5px
            width 64px
            height 22px
            border 1px solid #1972FF
            text-align center
            line-height 22px
            font-size 12px
            color #1972FF
    /deep/.el-textarea .el-input__count
        bottom: -40px
    .tips{
        color: #777;
        font-size: 13px;
    }
</style>